import { faFlag } from "@fortawesome/free-regular-svg-icons/faFlag"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
    HorizontalStack,
    componentStyles,
    ExternalLink,
    useColors,
} from "@mallardbay/lib-react-components"
import React from "react"

import ConditionalRenderContainer from "~components/shared/todo-lib-react-components/conditional-render-container"
import { Text } from "~components/shared/todo-lib-react-components/text"
import { COMPONENT_IDS } from "~config/constants"
import COPY_CONSTANTS from "~config/copy-constants"

export default function ReportListingButton({
    hideReportListingButton,
}: {
    readonly hideReportListingButton?: boolean
}) {
    const styles = useStyles()

    return (
        <ConditionalRenderContainer
            style={styles.report}
            shouldRender={!hideReportListingButton}
        >
            <ExternalLink
                href="/help"
                isUnderlined
                // id for scroll to element after selecting a package
                // scroll to this element at end of the page so that the
                // continue button is visible and not at the very edge of the view port
                id={COMPONENT_IDS.REPORT_LISTING}
            >
                <HorizontalStack style={styles.reportRow}>
                    <FontAwesomeIcon style={styles.reportIcon} icon={faFlag} />
                    <Text style={styles.reportText}>
                        {COPY_CONSTANTS.REPORT_THIS_LISTING}
                    </Text>
                </HorizontalStack>
            </ExternalLink>
        </ConditionalRenderContainer>
    )
}

function useStyles() {
    const colors = useColors()
    return componentStyles({
        report: {
            display: { base: "none", sm: "block" },
            marginTop: "1rem",
            marginBottom: "1rem",
        },
        reportRow: {
            justifyContent: "center",
        },
        reportIcon: {
            fontSize: 14,
            color: colors.contentSecondary,
        },
        reportText: {
            fontSize: "15px",
            textDecoration: "underline",
            color: colors.contentSecondary,
            ":hover": {
                cursor: "pointer",
            },
        },
    })
}
